// @ts-ignore
export const fetcher = (...args) => fetch(...args).then((res) => res.json())
// @ts-ignore
export const fetcherText = (...args) => fetch(...args).then((res) => res.text())

export const timeoutFetcher = async (url: string, options: RequestInit) => {
	const timeoutDuration = 5000 // Timeout duration in milliseconds

	const timeoutPromise = new Promise<unknown>((_, reject) => {
		setTimeout(() => {
			reject(new Error('Request timed out'))
		}, timeoutDuration)
	})

	const fetchPromise = fetch(url, options)

	try {
		const response = await Promise.race([fetchPromise, timeoutPromise])
		if (response instanceof Response) {
			return response.json()
		}
		throw new Error('Invalid response received')
	} catch (error) {
		console.error(error)
		throw error
	}
}

export const postFetcher = (...args: any[]) => {
	if (args[0].includes('null') || args[0].includes('undefined')) {
		return { data: {}, isLoading: false }
	}

	return fetch(args[0], {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' }
	}).then((res) => res.json())
}

// @ts-ignore
export const noStoreFetcher = (...args) => {
	const input = `${args[0]}`
	const init = args[1] || {}
	const p = { ...init, cache: 'no-store' }
	return fetch(input, p).then((res) => res.json())
}

const checkedArrayResponse = async (input: RequestInfo | URL, init?: RequestInit) => {
	const response = await fetch(input, init)
	if (!response.ok) {
		throw new Error(`HTTP ${response.status} fetching ${String(input)}`)
	}
	const body: unknown = await response.json()
	if (!Array.isArray(body)) {
		throw new Error(`Invalid array response from ${String(input)}`)
	}
	return body
}

export const arrayFetcher = (input: RequestInfo | URL, init?: RequestInit) =>
	checkedArrayResponse(input, init)

export const noStoreArrayFetcher = (input: RequestInfo | URL, init?: RequestInit) =>
	checkedArrayResponse(input, { ...init, cache: 'no-store' })
